import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './components/HeroSection';
import WhatToExpectFromAppointment from './components/WhatToExpect';
import DuringEvaluationSection from './components/DuringEvaluation';
import ExpectFromTelehealth from './components/ExpectFromTelehealth';
import PaymentSection from './components/PaymentSection';
import { useLocation } from 'react-router-dom';

const YourAppointmentPage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
      }
    }
  }, [location]);

  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>Your Appointment | Guidepost Pediatrics</title>
        <meta
          name="description"
          content="Learn what to expect at your child's pediatric therapy evaluation at Guidepost in Wasilla, Alaska. Information about the evaluation process, telehealth options, and payment."
        />
        <meta
          name="keywords"
          content="pediatric therapy appointment, therapy evaluation Wasilla, what to expect therapy appointment, pediatric evaluation Alaska"
        />
      </Helmet>
      <HeroSection />
      <WhatToExpectFromAppointment />
      <DuringEvaluationSection />
      <ExpectFromTelehealth />
      <PaymentSection />
    </div>
  );
};

export default YourAppointmentPage;
